import React from "react";
import constants from "../../../utilities/constants.json";
import Moment from "moment";
import { useCountdown } from "../../../utilities/timer";

const PredictionCountDown = ({ timeString }) => {
  const { days, hours, minutes, seconds } = useCountdown(timeString);

  const matchNotStarted = React.useMemo(() => {
    const predictionEndTime = new Date(
      Moment(timeString, "YYYY-MM-DD HH:mm:ss").format("MMM DD, YYYY HH:mm:ss"),
    ).getTime();

    const currentTime = new Date(
      Date.parse(
        Moment.utc()
          .utcOffset(constants.timeOffset)
          .format("YYYY-MM-DDTHH:mm:ss"),
      ),
    ).getTime();

    return predictionEndTime > currentTime;
  }, [timeString]);

  return (
    <h6>
      {matchNotStarted
        ? days === 0
          ? hours + ":" + minutes + ":" + seconds
          : days > 1
            ? days + " days " + hours + ":" + minutes + ":" + seconds
            : days + " day  " + hours + ":" + minutes + ":" + seconds
        : "Expired"}
    </h6>
  );
};

export default PredictionCountDown;
